// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#626466","menuActiveText":"#313233","menuBg":"#f0f5f4"};